/** Safe editor drafts, independent of private game engines and pack content. */
export type EditableSettings = Record<string, unknown>;
export type EditableCustomPack = {
  name: string;
  kind: string;
  entries: unknown[];
};
const customKeys = [
  "customWords",
  "customPairs",
  "customLocations",
  "customScales",
] as const;

function withoutPackBodies(settings: EditableSettings): EditableSettings {
  const draft = structuredClone(settings);
  for (const key of customKeys) delete draft[key];
  delete draft.customPackSummary;
  delete draft.customPackName;
  return draft;
}

/** Only the uploader's explicitly authorized private editor view supplies entries.
 * A replacement host starts with the built-in pack; the UI must disclose this
 * before saving because public pack summaries cannot roundtrip private content.
 */
export function editorSettings(
  defaults: EditableSettings,
  publicSettings: EditableSettings,
  editableCustomPack: EditableCustomPack | null | undefined,
): EditableSettings {
  const draft = withoutPackBodies({ ...defaults, ...publicSettings });
  if (draft.packId !== "custom") return draft;
  if (
    editableCustomPack &&
    customKeys.some((key) => key === editableCustomPack.kind)
  ) {
    draft.customPackName = editableCustomPack.name;
    draft[editableCustomPack.kind] = structuredClone(
      editableCustomPack.entries,
    );
  } else if (defaults.packId !== undefined) {
    draft.packId = defaults.packId;
  } else {
    delete draft.packId;
  }
  return draft;
}

/** A different Impostor variant has a different pack shape, never reinterpret it. */
export function changeVariant(
  settings: EditableSettings,
  variant: "blank" | "related",
): EditableSettings {
  return { ...withoutPackBodies(settings), variant, packId: "everyday" };
}
